module.exports = __webpack_public_path__ + "img/sy.2311ac58.svg";